import { open as openPopup } from '../popup';
import request, { endpoint } from './request';

export function authConnector(service, successCallback, errorCallback) {
  openPopup(`${endpoint}/auth/${service}`);

  const onMessageFunc = (event) => {
    if (event.data.type === 'clearbitAuthComplete') {
      successCallback(event.data);
    } else if (event.data.type === 'clearbitAuthError') {
      errorCallback(event.data);
    }

    window.removeEventListener('message', onMessageFunc, false);
  };

  window.onmessage = onMessageFunc;
}

export function getCurrentUser() {
  return request({
    path: '/v1/users/current',
  });
}

export function getCurrentAccount() {
  return request({
    path: '/v1/accounts/current',
  });
}

export function authUser() {
  window.location = `${endpoint}/auth`;
}

export function logoutUser() {
  window.location = '/logout';
}
